import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

// Services
import { RouteParam, ServiceBase } from '../service-base';

// Modèles
import { Bank } from 'src/app/@shared/models/banking/config/bank.model';

const CLASS_NAME = 'Bank';
const ENDPOINT = `/banks/`;
const ROUTES: RouteParam[] = [
    { key: 'connect', path: '{id}/connect/' },
]

@Injectable({
    providedIn: 'root'
})
export class BankService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }

    public getConnectUrl$(bank: Bank, params: any): Observable<any> {
        let url = this.routes.connect.replace('{id}', bank.id.toString());
        return this.httpClient.post(url, params).pipe(
            map((data: any) => {
                return data.url;
            }),
            catchError(
                (error: any) => {
                    // Manage error
                    this.handleError(error);
                    return of(false);
                }
            )
        );
    }
}
